import { createDomain } from 'effector';
import { omit } from 'lodash';

import api from 'api';

import { Participant } from 'types/zod/participant';

const domain = createDomain('api/participants');

const ParticipantsFxs = {
    _createParticipantFx: domain.effect(api.participants.createParticipant),
    createParticipantFx: domain.effect(async (participant: Participant) => {
        if (participant?.email === '') {
            participant = omit(participant, 'email');
        }
        return await api.participants.createParticipant(participant);
    }),
    _updateParticipantFx: domain.effect(api.participants.updateParticipant),
    updateParticipantFx: domain.effect(async (participant: Participant) => {
        if (participant?.email === '') {
            participant = omit(participant, 'email');
        }
        return await api.participants.updateParticipant(participant);
    }),
    deleteObserverFx: domain.effect(api.participants.deleteObserver),
    findParticipantFx: domain.effect(api.participants.findParticipant),
    getAdvisorByIdFx: domain.effect(api.participants.getAdvisorById),
    getAdvisorsFx: domain.effect(api.participants.getAdvisors),
    getCommunityFx: domain.effect(api.participants.getCommunity),
    getFolderPathFx: domain.effect(api.participants.getFolderPath),
    getMeFx: domain.effect(api.participants.getMe),
    getParticipantFx: domain.effect(api.participants.getParticipant),
    getAdvisorParticipantFx: domain.effect(api.participants.getAdvisorParticipant),
    getParticipantsFx: domain.effect(api.participants.getParticipants),
    getTempUserFx: domain.effect(api.participants.getTempUser),
    isDirectInvoicingFx: domain.effect(api.participants.isDirectInvoicing),
    linkRegisteredUserFx: domain.effect(api.participants.linkRegisteredUser),
    lookupAddressesFx: domain.effect(api.participants.lookupAddresses),
    resendNotificationsFx: domain.effect(api.participants.resendNotifications),
    sendInvitationFx: domain.effect(api.participants.sendInvitation),
    setMailingAddressFx: domain.effect(api.participants.setMailingAddress),
    setNewUserEmailFx: domain.effect(api.participants.setNewUserEmail),
    updateEmailFx: domain.effect(api.participants.updateEmail),
    updateParticipantsFx: domain.effect(api.participants.updateParticipants),
    verifyLinkingFx: domain.effect(api.participants.verifyLinking),
    updateUserSettingsFx: domain.effect(api.participants.updateUserSettings),
    getParticipantReferencesFx: domain.effect(api.participants.getParticipantReferences),
    removeParticipantFx: domain.effect(api.participants.removeParticipant),
};

export default ParticipantsFxs;
